module.exports = __webpack_public_path__ + "static/media/workVan_red.24af14be.svg";